import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useQuery } from "react-query";
import authApi from "../../service/IdApi";
import { useAppContext } from "../../context/appContext";
import PageLoading from "../../components/PageLoading";
import PageLoadError from "../../components/PageLoadError";
import PageHeading from "../../components/PageHeading";
import { Button } from "primereact/button";
import { Mixpanel } from "../../utils/Mixpanel";

const MyCompanies = () => {
    const { switchCompany, switchCompanyToProfile } = useAppContext();
    const navigate = useNavigate();
    const [providers, setProviders] = useState(null);
    const [providerCount, setProviderCount] = useState(0);
    const [providersLoaded, setProvidersLoaded] = useState(false);

    const { isLoading, isError, data } = useQuery(
        "Providers",
        async () => {
            const result = await authApi.get("auth/providers", "", {
                withCredentials: true,
            });
            setProviders(result.data.providers);
            setProviderCount(result.data.providers.length);
            setProvidersLoaded(true);
            return data;
        },
        { retry: 2, retryDelay: 3000 }
    );

    // useEffect(() => {
    //     TokenService.getProviderSubdomain();
    // }, []);

    const openNew = () => {
        window.location.href = process.env.REACT_APP_NETWORK_SITE + "/company/create-profile";
    };

    const pageHeader = (
        <PageHeading pageTitle="My Companies">
            <div className="block">
                <Button label="Create" icon="pi pi-plus" className="mr-2" onClick={openNew} />
            </div>
        </PageHeading>
    );

    useEffect(() => {
        Mixpanel.track("UI ID - My Companies page view");
    }, []);

    if (isLoading) {
        return (
            <div>
                {pageHeader}
                <PageLoading />
            </div>
        );
    }

    if (isError) {
        return (
            <div>
                {pageHeader}
                <PageLoadError />
            </div>
        );
    }

    if (!providersLoaded) {
        return (
            <div>
                {pageHeader}
                <PageLoading />
            </div>
        );
    }

    // const onRowSelect = (event) => {
    //     switchCompany(event.data.name, event.data._id);
    // };

    // const changeCompanies = (e) => {
    //     console.log(e);
    // }

    const switchProvider = (name, id) => {
        switchCompany(name, id);
    }

    const switchProviderToProfile = (name, id, vanityName) => {
        switchCompanyToProfile(name, id, vanityName);
    }

    // const nameBodyTemplate = (rowData) => {
    //     return <>{rowData.name}</>;
    // };

    // const subdomainBodyTemplate = (rowData) => {
    //     var sd = "";
    //     if (rowData.subdomain && rowData.subdomain !== "") {
    //         sd = rowData.subdomain;
    //     }
    //     else {
    //         sd = rowData.providerNumber;
    //     }
    //     var linkUrl = "https://" + sd + process.env.REACT_APP_PROVIDER_SITE;
    //     return (
    //         <>{linkUrl}</>
    //     );
    // };

    // const addressBodyTemplate = (rowData) => {
    //     return (
    //         <>
    //             <span className="white-space-nowrap">
    //                 {rowData.address}
    //                 {rowData.address2 && <br />}
    //                 {rowData.address2}
    //             </span>
    //             <span>
    //                 {rowData.city && <br />}
    //                 {rowData.city}
    //                 {rowData.city && <span>, </span>}
    //                 {rowData.stateCode} {rowData.zipCode}
    //             </span>
    //         </>

    //     );
    // };

    const createdOnBodyTemplate = (rowData) => {
        var dt = new Date(rowData.createdAt);
        var d = dt.getDate();
        var m = dt.getMonth() + 1;
        var y = dt.getFullYear();
        var dateString = (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d) + '-' + y;
        return <>{dateString}</>;
    };

    const goToNetworkSite = () => {
        window.location.href = process.env.REACT_APP_NETWORK_SITE + "/browse/companies";
    }

    return (
        <div>
            {pageHeader}
            <div className="layout-content">
                {providerCount > 0 && (
                    <div className="card pt-3 sm:pt-0">
                        {providerCount > 1 && (
                            <div className="text-xl py-3 mr-3">
                                Click on the provider below to manage the Service Provider business.
                            </div>
                        )}
                        {providerCount === 1 && (
                            <div className="text-xl mr-3 py-3">
                                Click on the company below to manage your business. If you own multiple businesses, you can create another provider using the Create button above.
                            </div>
                        )}
                        {providers.map((provider, index) =>
                            <div key={index} className=" px-2 pb-3 border-bottom-1 border-400">
                                <Button type="link" onClick={() => switchProvider(provider.name, provider._id)} className="p-button-text text-lg pl-0 pr-0 text-left" label={provider.name}></Button>
                                <div>
                                    <span className="white-space-nowrap">
                                        {provider.address}
                                        {provider.address2 && <br />}
                                        {provider.address2}
                                    </span>
                                    <span>
                                        {provider.city && <br />}
                                        {provider.city}
                                        {provider.city && <span>, </span>}
                                        {provider.stateCode} {provider.zipCode}
                                    </span>
                                </div>
                                {provider.vanityName && (
                                    <div className="mt-2">
                                        Public Profile: <a onClick={() => switchProviderToProfile(provider.name, provider._id, provider.vanityName)} className="cursor-pointer" >{"wallist.com/company/" + provider.vanityName}</a>
                                    </div>
                                )}
                                <div className="mt-2">
                                    Created On: {createdOnBodyTemplate(provider)}
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {providerCount === 0 && (
                    <div className="pages-panel card flex flex-column text-center">
                        <div className="text-2xl mb-2 font-semibold">You have no companies on Wallist</div>
                        <div className="text-lg mb-4">Let's get started!</div>
                        <div className="grid">
                            <div className="col-12 md:col-6 p-5">
                                <div className="font-bold text-xl mb-2">
                                    Are you looking for help?
                                </div>
                                <div className="mb-2">Find top-rated landscapers, painters, plumbers, electricians, and other professionals in your area to help you!</div>
                                <div>
                                    <Button label="Find Service Providers" onClick={goToNetworkSite} />
                                </div>
                            </div>
                            <div className="col-12 md:col-6 border-500 border-top-1 md:border-top-none border-left-0 md:border-left-1 p-5">
                                <div className="font-bold text-xl mb-2">
                                    Are you a small business owner?
                                </div>
                                <div className="mb-2">List your business profile on Wallist for free! You can also manage your customers, create quotes & invoices, and collect payments all through Wallist!</div>
                                <div>
                                    <Button label="List Your Business" onClick={openNew} />
                                </div>
                            </div>
                        </div>
                    </div>
                    // <div className="card">
                    //     <div className="grid grid-nogutter surface-section text-800">
                    //         <div className="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center ">
                    //             <section>
                    //                 <span className="block text-4xl font-bold mb-1">
                    //                     Welcome to Wallist!
                    //                 </span>
                    //                 <span className="block text-xl mb-1">
                    //                     To get started, create your first Service Provider account.
                    //                 </span>
                    //                 <br />
                    //                 <Button type="link" icon="pi pi-plus" to="/account/create-provider" onClick={openNew} label="Create Provider" />
                    //             </section>
                    //         </div>
                    //         <div className="col-12 md:col-6 overflow-hidden text-center">
                    //             <img
                    //                 src="/assets/images/electrician.png"
                    //                 alt="hero-1"
                    //                 style={{ width: "75%" }}
                    //             />
                    //         </div>
                    //     </div>
                    // </div>
                )}
            </div>
        </div>
    );
};

export default MyCompanies;
